import * as React from 'react';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import { Divider } from '@mui/material';
import passo1img from '../../imgs/saude-bucal/higienizacao-bucal/passo-1-image.png';
import passo2img from '../../imgs/saude-bucal/higienizacao-bucal/passo-2-image.png';
import passo3img from '../../imgs/saude-bucal/higienizacao-bucal/passo-3-image.png';
import passo4img from '../../imgs/saude-bucal/higienizacao-bucal/passo-4-image.png';
import passo5img from '../../imgs/saude-bucal/higienizacao-bucal/passo-5-image.png';
import passo6img from '../../imgs/saude-bucal/higienizacao-bucal/passo-6-image.png';
import passo7img from '../../imgs/saude-bucal/higienizacao-bucal/passo-7-image.png';
import imgHigienizacao from '../../imgs/saude-bucal/higienizacao-bucal/image-1.png';
import imgDicas from '../../imgs/saude-bucal/higienizacao-bucal/dicas-image.png';
import { useIsMobile } from '../../hooks/useIsMobile';

export default function HigienizacaoBucal() {
    const isMobile = useIsMobile();
    const arrayTimeline = [
        {
            title: '1° Passo',
            description: 'Inserir na gengiva as cerdas da escova, fazendo movimentos vibratórios e de varredura.',
            image: passo1img
        },
        {
            title: '2° Passo',
            description: 'Nos dentes de baixo, repita o movimento de baixo para cima.',
            image: passo2img
        },

        {
            title: '3° Passo',
            description: 'Fazer o movimento de "vassourinha" nos dentes de cima e de baixo.',
            image: passo3img
        },
        {
            title: '4° Passo',
            description: 'Realizar movimento circulares na parte de fora dos dentes.',
            image: passo4img
        },
        {
            title: '5° Passo',
            description: 'Realizar movimento de vai e vem na parte onde mordemos os alimentos.',
            image: passo5img
        },
        {
            title: '6° Passo',
            description: 'Escovar a língua com movimentos de dentro para fora.',
            image: passo6img
        },
        {
            title: 'Atenção!',
            description: 'Não esqueça do fio dental',
            image: passo7img
        }
    ]
    return (
        <div className="container" style={{ paddingTop: 60, background: 'linear-gradient(to bottom, #d9f9e6, #ffffff)' }}>
            <div>
                <h1 className='title'>Higienização Bucal </h1>

                <div style={{ display: 'flex', alignContent: 'center', flexDirection: isMobile ? 'column' : 'row' }}>
                    {isMobile ? (
                        <p>Cuidar da boca é cuidar do corpo! Quando os dentes não são bem escovados, restos de comida e açúcar favorecem bactérias que causam cáries e outros problemas. Mas tudo isso pode ser evitado com hábitos simples: escovar os dentes após as refeições, usar fio dental e contar com o flúor, presente até na água que bebemos. Prevenir é sempre o melhor caminho!</p>
                    ) : (
                        <p>
                            Quando a gente não escova bem os dentes, os restos de comida ficam ali parados e viram um prato cheio para as bactérias. Elas usam o açúcar dos alimentos para produzir ácidos que vão desgastando o esmalte dos dentes, e aí nasce a temida cárie. Se ninguém fizer nada, o dente pode até se destruir por completo!<br /><br />
                            Mas, a boa notícia é que dá para evitar tudo isso com hábitos bem simples: escovar os dentes depois das refeições, usar fio dental e contar com a ajuda do flúor (que está até na água que a gente bebe!). Esses cuidados ajudam a deixar os dentes mais fortes e protegidos. Então, vai além de ter um sorriso bonito ou um hálito legal, é sobre saúde de verdade. Prevenir é muito mais fácil do que tratar depois. E tudo começa com uma boa escova de cerdas macias, creme dental com flúor e a sua vontade de se cuidar todos os dias!
                        </p>

                    )}

                    <img src={imgHigienizacao} alt="Higienização bucal" />
                </div>
            </div>
            <Divider style={{ marginBottom: '20px' }} />
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <p>A higiene bucal é o primeiro passo para manter um sorriso saudável!<br /></p>
                <h4 style={{ textAlign: 'center' }}>Vamos aprender a escovar os dentes e passar o fio dental corretamente?</h4>
            </div>
            <Timeline position="alternate-reverse">
                {arrayTimeline.map((item, index) => (
                    <TimelineItem key={index}>
                        <TimelineSeparator>
                            <TimelineDot />
                            <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent>
                            <h2>{item.title}</h2>
                            <p
                                style={{
                                    textAlign: index % 2 === 0 ? 'right' : 'left',
                                }}
                            >{item.description}</p>
                            <img src={item.image} alt="passo1img" style={{ width: '100%', maxWidth: '200px' }} />
                        </TimelineContent>
                    </TimelineItem>
                ))}
            </Timeline>
            <Divider style={{ marginTop: '20px' }} />
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <img src={imgDicas} alt="Dicas de higienização bucal" style={{ width: '100%', maxWidth: '500px' }} />
            </div>
            <h2 style={{ textAlign: 'center' }} > Com o vídeo abaixo a escovação ficará mais fácil!</h2>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: 120, marginTop: 60 }}>
                <iframe
                    width="360"
                    height="640"
                    src="https://www.youtube.com/embed/4dbwGxxX2RM"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen
                ></iframe>
            </div>
        </div>
    );
}
